import { ApiProperty } from '@nestjs/swagger';
import { ArrayNotEmpty, ArrayUnique, IsArray, IsUUID } from 'class-validator';

export class ReordenarEtapasDto {
  @ApiProperty({
    type: [String],
    description:
      'Ids de TODAS las etapas activas del pipeline, en el orden deseado. ' +
      'Se rechaza si falta alguna o si sobra una que no pertenece al pipeline.',
  })
  @IsArray()
  @ArrayNotEmpty()
  @ArrayUnique()
  @IsUUID('4', { each: true })
  etapa_ids: string[];
}
